import React from 'react';
import { Grid, Card, CardContent, Box, Typography } from '@mui/material';
import {
  Security as SecurityIcon,
  Warning as WarningIcon,
  Error as ErrorIcon,
  CheckCircle as CheckIcon,
} from '@mui/icons-material';

/**
 * AuditSummaryCards Component
 *
 * Displays summary statistics cards for the audit dashboard.
 *
 * @param {Object} props
 * @param {Array} props.auditLogs - Array of audit log entries
 * @param {number} props.totalCount - Total count of audit logs
 */
function AuditSummaryCards({ auditLogs, totalCount }) {
  const anonymizedCount = auditLogs.filter(log => log.was_anonymized).length;
  const totalViolations = auditLogs.reduce(
    (sum, log) => sum + (log.total_violations || 0),
    0
  );
  const cleanChecks = auditLogs.filter(
    log => log.total_violations === 0
  ).length;

  return (
    <Grid container spacing={3} sx={{ mb: 3 }}>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Card>
          <CardContent>
            <Box display="flex" alignItems="center">
              <SecurityIcon color="primary" sx={{ mr: 2 }} />
              <Box>
                <Typography variant="h6">{totalCount}</Typography>
                <Typography variant="body2" color="text.secondary">
                  Total Checks
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Card>
          <CardContent>
            <Box display="flex" alignItems="center">
              <WarningIcon color="warning" sx={{ mr: 2 }} />
              <Box>
                <Typography variant="h6">{anonymizedCount}</Typography>
                <Typography variant="body2" color="text.secondary">
                  Anonymized
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Card>
          <CardContent>
            <Box display="flex" alignItems="center">
              <ErrorIcon color="error" sx={{ mr: 2 }} />
              <Box>
                <Typography variant="h6">{totalViolations}</Typography>
                <Typography variant="body2" color="text.secondary">
                  Total Violations
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Card>
          <CardContent>
            <Box display="flex" alignItems="center">
              <CheckIcon color="success" sx={{ mr: 2 }} />
              <Box>
                <Typography variant="h6">{cleanChecks}</Typography>
                <Typography variant="body2" color="text.secondary">
                  Clean Checks
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}

export default AuditSummaryCards;
